import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styled from "styled-components";

const AnalyticsSkeleton = () => {
  return (
    <SkeletonContainer>
      {/* Tabs Skeleton */}
      <TabsWrapper>
        {Array.from({ length: 5 }).map((_, idx) => (
          <TabBox key={idx}>
            <Skeleton height={20} width={80} />
          </TabBox>
        ))}
      </TabsWrapper>

      {/* Metrics Grid */}
      <MetricsGrid>
        {Array.from({ length: 28 }).map((_, idx) => (
          <MetricBox key={idx}>
               <Skeleton height={15} width="60%" style={{ marginBottom: "8px" }} />
            <Skeleton height={30} width="40%" />
          </MetricBox>
        ))}
      </MetricsGrid>
    </SkeletonContainer>
  );
};

export default AnalyticsSkeleton;

// Styled Components
const SkeletonContainer = styled.div`
  background: ${({ theme }) =>
    theme?.dark ? theme?.darkThemBoxBgColor : "#fff"};
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const TabsWrapper = styled.div`
  background:  ${({ theme }) => (theme?.dark ? theme?.dark: '#f5f5f5')};
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  border-radius:5px;
`;

const TabBox = styled.div`
  background:  ${({ theme }) => (theme?.dark ? theme?.dark: '#f5f5f5')};;
  border-radius: 8px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  height: 40px;

  span {
    border-radius: 6px !important;
  }
`;

const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 per row */
  gap: 20px;
`;

const MetricBox = styled.div`
  background:  ${({ theme }) => (theme?.dark ? theme?.dark: '#f5f5f5')};;
  border-radius: 12px;
  padding: 20px;
  span {
    border-radius: 8px !important;
  }
`;
